import _regeneratorRuntime from "D:/work/code/2026/Halov2-Fishery-Upgrade/halov-web/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _objectSpread from "D:/work/code/2026/Halov2-Fishery-Upgrade/halov-web/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "D:/work/code/2026/Halov2-Fishery-Upgrade/halov-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _createForOfIteratorHelper from "D:/work/code/2026/Halov2-Fishery-Upgrade/halov-web/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url.to-json.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import dayjs from 'dayjs';
import Html2Canvas from 'html2canvas';
import axios from 'axios';
export default {
  name: 'source_batch_page',
  components: {
    videoSel: function videoSel() {
      return import('../iot/video/video_sel');
    },
    deviceSel: function deviceSel() {
      return import('../iot/smartControl/smartControl_sel');
    },
    taskSel: function taskSel() {
      return import('../grow/task_sel');
    },
    labSel: function labSel() {
      return import('../org/lab_sel.vue');
    },
    reportSel: function reportSel() {
      return import('./source_report_sel.vue');
    }
  },
  data: function data() {
    return {
      dayjs: dayjs,
      pageConfig: {
        editPageName: '溯源批次',
        addFunName: 'sourceBatchAdd',
        modifyFunName: 'sourceBatchModify',
        queryFunName: 'sourceBatchQuery',
        detailFunName: 'sourceBatchDetail',
        delFunName: 'sourceBatchDel',
        dicTreeFunName: 'dictionaryCache',
        seedDateFunName: 'fisheryTaskCatchSeedDate'
      },
      searchForm: {
        page: 1,
        limit: 10,
        searchKey: null,
        sortField: 'issue_date,create_time'
      },
      formData: {
        reportFiles: [],
        videoType: 'Current',
        environmentType: 'Current',
        promiseAbideStipulate: true,
        promiseConformStandard: true,
        promiseIllegalityAdditive: true,
        promiseProhibitPesticide: true,
        promiseSelfInspect: true,
        sourceStyle: 1,
        environmentShow: false,
        merchantShow: false,
        productShow: false,
        reportShow: false,
        videoShow: false,
        taskShow: false
      },
      rules: {
        labId: [{
          required: true,
          message: '请选择所属企业',
          trigger: 'blur'
        }],
        taskCatchId: [{
          required: true,
          message: '请选择捕捞批次',
          trigger: 'blur'
        }]
      },
      queryLoading: true,
      tableData: [],
      totalCount: 0,
      editDialogShow: false,
      editDialogTitle: '',
      formLabelWidth: '140px',
      emptyFormData: {},
      video_show: false,
      device_show: false,
      deviceHistory_show: false,
      catch_show: false,
      preview_show: false,
      preview_code: '',
      deviceItem: [],
      dicData: {
        typeUpperCode: 'iot_sensor_item',
        configTypes: [],
        configTypeOptions: {}
      },
      certificate_title: '',
      lab_show: false,
      report_show: false
    };
  },
  watch: {
    deviceHistory_show: function deviceHistory_show(to) {
      if (!to) {
        this.deviceItem = [];
        var _iterator = _createForOfIteratorHelper(this.dicData.configTypes),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var item = _step.value;
            this.deviceItem.push({
              name: item.name,
              code: item.code,
              lastValue: '',
              unit: ''
            });
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      } else {
        if (this.formData.environmentDeviceHistory.text) {
          this.deviceItem = this.formData.environmentDeviceHistory.data;
        }
      }
    }
  },
  mounted: function mounted() {
    var _this = this;
    this.$api[this.pageConfig.dicTreeFunName](this.dicData.typeUpperCode).then(function (res) {
      if (res.data) {
        _this.dicData.configTypes = res.data;
        var _iterator2 = _createForOfIteratorHelper(res.data),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var item = _step2.value;
            _this.dicData.configTypeOptions[item.code] = item.name;
            _this.deviceItem.push({
              name: item.name,
              code: item.code,
              lastValue: '',
              unit: ''
            });
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
        _this.emptyFormData = JSON.parse(JSON.stringify(_this.formData));
        _this.query();
      }
    });
  },
  methods: {
    initFormData: function initFormData(data) {
      var paramData = JSON.parse(JSON.stringify(data));
      this.formData = paramData;
      if (!this.formData.reportFiles) {
        this.$set(this.formData, 'reportFiles', []);
      } else {
        if (typeof this.formData.reportFiles === 'string') {
          this.$set(this.formData, 'reportFiles', this.formData.reportFiles.split(','));
        }
      }
      if (this.formData.startDate) {
        this.$set(this.formData, 'startDate', this.dayjs(paramData.startDate).format('YYYY-MM-DD HH:mm:ss'));
      }
      if (this.formData.endDate) {
        this.$set(this.formData, 'endDate', this.dayjs(paramData.endDate).format('YYYY-MM-DD HH:mm:ss'));
      }
      if (this.formData.issueDate) {
        this.$set(this.formData, 'issueDate', this.dayjs(paramData.issueDate).format('YYYY-MM-DD HH:mm:ss'));
      }
      if (typeof this.$refs['formDataVerify'] !== 'undefined') {
        this.$refs['formDataVerify'].clearValidate();
      }
    },
    saveFormDataProcess: function saveFormDataProcess(formData) {
      var saveFormData = JSON.parse(JSON.stringify(formData));
      return saveFormData;
    },
    add: function add() {
      this.editDialogTitle = this.pageConfig.editPageName + '新增';
      this.initFormData(this.emptyFormData);
      this.editDialogShow = true;
    },
    edit: function edit(_ref) {
      var _this2 = this;
      var id = _ref.id,
        labName = _ref.labName;
      this.$api[this.pageConfig.detailFunName](id).then(/*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(res) {
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                _this2.initFormData(_objectSpread(_objectSpread({}, res.data), {}, {
                  labName: labName
                }));
                _this2.editDialogTitle = _this2.pageConfig.editPageName + '维护';
                _this2.editDialogShow = true;
              case 3:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        return function (_x) {
          return _ref2.apply(this, arguments);
        };
      }());
    },
    videoSel: function videoSel(data) {
      if (data) {
        this.$set(this.formData, 'videoId', data.id);
        this.$set(this.formData, 'videoUrl', data.videoName);
      }
      this.video_show = false;
    },
    videoTypeInput: function videoTypeInput() {
      this.$set(this.formData, 'videoId', null);
      this.$set(this.formData, 'videoUrl', null);
    },
    deviceSel: function deviceSel(data) {
      if (data) {
        this.$set(this.formData, 'environmentDeviceId', data.id);
        this.$set(this.formData, 'environmentDeviceHistory', data.name);
      }
      this.device_show = false;
    },
    environmentTypeInput: function environmentTypeInput(val) {
      if (val == 'Current') {
        this.$set(this.formData, 'environmentDeviceHistory', null);
      } else if (val == 'History') {
        this.$set(this.formData, 'environmentDeviceHistory', {});
      }
    },
    submitDeviceHistory: function submitDeviceHistory() {
      var text = [];
      var _iterator3 = _createForOfIteratorHelper(this.deviceItem),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var item = _step3.value;
          if (item.lastValue !== '') {
            text.push("".concat(item.name, "\uFF1A").concat(item.lastValue).concat(item.unit));
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
      if (!text.length) {
        this.$message.info('请输入参数值');
        return;
      }
      this.$set(this.formData, 'environmentDeviceHistory', {
        text: text.toString(),
        data: this.deviceItem
      });
      this.deviceHistory_show = false;
    },
    taskClick: function taskClick() {
      if (!this.formData.labId) {
        this.$message.info('请先选择所属企业！');
        return;
      }
      this.catch_show = true;
    },
    taskSel: function taskSel(data) {
      if (data) {
        this.$set(this.formData, 'taskCatchId', data.id);
        this.$set(this.formData, 'taskBatchCode', data.taskBatchCode);
        // this.$api[this.pageConfig.seedDateFunName](data.id).then((res) => {
        //   if (res.data) {
        //     this.$set(this.formData, 'startDate', res.data.seedDate + '')
        //     this.$set(this.formData, 'endDate', res.data.catchDate + '')
        //   }
        // })
      }
      this.catch_show = false;
    } // 选择企业
    ,
    labSel: function labSel(data) {
      if (data) {
        this.formData.labId = data.id;
        this.$set(this.formData, 'labName', data.name);
        this.$set(this.formData, 'taskCatchId', null);
        this.$set(this.formData, 'taskBatchCode', '');
      }
      this.lab_show = false;
    },
    styleClick: function styleClick(val) {
      this.$set(this.formData, 'sourceStyle', val);
    },
    code: function code(data) {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var res;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _this3.initFormData(data);
            case 2:
              _this3.certificate_title = '合格证/溯源码';
              _context2.prev = 3;
              _context2.next = 6;
              return axios({
                url: "".concat(process.env.VUE_APP_API, "/wechat/applet/minicode/").concat(data.id),
                method: 'GET',
                params: {
                  page: "src/pagesA/source/traceCode"
                },
                headers: {
                  'Content-Type': 'application/json;charset=UTF-8',
                  'Authorization': localStorage.getItem('token')
                },
                responseType: 'blob' // 关键！
              });
            case 6:
              res = _context2.sent;
              _this3.preview_code = URL.createObjectURL(res.data);
              _this3.preview_show = true;
              _context2.next = 14;
              break;
            case 11:
              _context2.prev = 11;
              _context2.t0 = _context2["catch"](3);
              console.error('加载图片失败', _context2.t0);
            case 14:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[3, 11]]);
      }))();
    },
    exportClick: function exportClick() {
      try {
        // 文件名称
        var filename = '合格证';
        Html2Canvas(document.querySelector('#export-image'), {
          // scale: 2,
          useCORS: true,
          ignoreElements: function ignoreElements(element) {
            // 跳过指定元素
            // 跳过下载按钮
            if (element.id === 'downFileBtn') {
              return true;
            }
          }
        }).then(function (canvas) {
          var img = document.createElement('a');
          img.href = canvas.toDataURL('image/png');
          img.download = filename;
          img.click();
        });
      } catch (error) {
        console.log(error);
      }
    } // 选择溯源报告
    ,
    reportSel: function reportSel(val) {
      if (val) {
        this.formData.reportFiles.push(val.reportUrl);
      }
      this.report_show = false;
    },
    del: function del(id) {
      var _this4 = this;
      this.$confirm('确定要删除吗').then(function () {
        _this4.$api[_this4.pageConfig.delFunName](id).then(function (res) {
          if (res.data) {
            _this4.$message.success('删除成功');
            _this4.query();
          } else {
            _this4.$message.error('删除失败');
          }
        });
      });
    },
    query: function query() {
      var _this5 = this;
      this.queryLoading = true;
      this.$api[this.pageConfig.queryFunName](this.searchForm).then(function (res) {
        _this5.tableData = res.data || [];
        _this5.totalCount = res.count;
        _this5.queryLoading = false;
      });
    },
    submitFormData: function submitFormData() {
      var _this6 = this;
      this.$refs['formDataVerify'].validate(function (valid) {
        if (valid) {
          if (_this6.formData.id) {
            _this6.$api[_this6.pageConfig.modifyFunName](_this6.saveFormDataProcess(_objectSpread(_objectSpread({}, _this6.formData), {}, {
              reportFiles: _this6.formData.reportFiles.toString()
            }))).then(function (res) {
              if (res.data) {
                _this6.$message.success('编辑成功');
                _this6.initFormData(_this6.emptyFormData);
                _this6.editDialogShow = false;
                _this6.query();
              } else {
                _this6.$message.error('编辑失败');
              }
            });
          } else {
            _this6.$api[_this6.pageConfig.addFunName](_this6.saveFormDataProcess(_objectSpread(_objectSpread({}, _this6.formData), {}, {
              reportFiles: _this6.formData.reportFiles.toString()
            }))).then(function (res) {
              if (res.data) {
                _this6.$message.success('新增成功');
                _this6.initFormData(_this6.emptyFormData);
                _this6.editDialogShow = false;
                _this6.query();
              } else {
                _this6.$message.error('新增失败');
              }
            });
          }
        }
      });
    },
    beforeImageUpload: function beforeImageUpload(file) {
      var isImage = ['image/jpeg', 'image/jpg', 'image/png'].includes(file.type);
      if (!isImage) {
        this.$message.error('文件必须是图片格式');
      }
      var isLt5M = file.size / 1024 / 1024 < 5;
      if (!isLt5M) {
        this.$message.error('图片大小不超过5M！');
      }
      return isImage && isLt5M;
    },
    beforeVideoUpload: function beforeVideoUpload(file) {
      var isImage = ['video/mp4', 'video/ogg', 'video/wmv'].includes(file.type);
      if (!isImage) {
        this.$message.error('文件必须是视频格式');
      }
      var isLt5M = file.size / 1024 / 1024 < 5;
      if (!isLt5M) {
        this.$message.error('视频大小不超过5M！');
      }
      return isImage && isLt5M;
    },
    productImageUpload: function productImageUpload(_ref3) {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var file;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              file = _ref3.file;
              _this7.$api.aliOssSign(localStorage.getItem('userId')).then(/*#__PURE__*/function () {
                var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3(res) {
                  var url;
                  return _regeneratorRuntime().wrap(function _callee3$(_context3) {
                    while (1) switch (_context3.prev = _context3.next) {
                      case 0:
                        _context3.next = 2;
                        return _this7.uploadFile(localStorage.getItem('userId'), dayjs().format('YYYYMMDD'), res.data, file);
                      case 2:
                        url = _context3.sent;
                        _this7.$set(_this7.formData, 'productImage', url);
                      case 4:
                      case "end":
                        return _context3.stop();
                    }
                  }, _callee3);
                }));
                return function (_x2) {
                  return _ref4.apply(this, arguments);
                };
              }());
            case 2:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    videoUrlUpload: function videoUrlUpload(_ref5) {
      var _this8 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var file;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              file = _ref5.file;
              _this8.$api.aliOssSign(localStorage.getItem('userId')).then(/*#__PURE__*/function () {
                var _ref6 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5(res) {
                  var url;
                  return _regeneratorRuntime().wrap(function _callee5$(_context5) {
                    while (1) switch (_context5.prev = _context5.next) {
                      case 0:
                        _context5.next = 2;
                        return _this8.uploadFile(localStorage.getItem('userId'), dayjs().format('YYYYMMDD'), res.data, file);
                      case 2:
                        url = _context5.sent;
                        _this8.$set(_this8.formData, 'videoUrl', url);
                      case 4:
                      case "end":
                        return _context5.stop();
                    }
                  }, _callee5);
                }));
                return function (_x3) {
                  return _ref6.apply(this, arguments);
                };
              }());
            case 2:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))();
    },
    certAgriculturalProductsFlagUpload: function certAgriculturalProductsFlagUpload(_ref7) {
      var _this9 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        var file;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              file = _ref7.file;
              _this9.$api.aliOssSign(localStorage.getItem('userId')).then(/*#__PURE__*/function () {
                var _ref8 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7(res) {
                  var url;
                  return _regeneratorRuntime().wrap(function _callee7$(_context7) {
                    while (1) switch (_context7.prev = _context7.next) {
                      case 0:
                        _context7.next = 2;
                        return _this9.uploadFile(localStorage.getItem('userId'), dayjs().format('YYYYMMDD'), res.data, file);
                      case 2:
                        url = _context7.sent;
                        _this9.$set(_this9.formData, 'certAgriculturalProductsFlag', url);
                      case 4:
                      case "end":
                        return _context7.stop();
                    }
                  }, _callee7);
                }));
                return function (_x4) {
                  return _ref8.apply(this, arguments);
                };
              }());
            case 2:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }))();
    },
    certEntrustPassedInspectionUpload: function certEntrustPassedInspectionUpload(_ref9) {
      var _this0 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee0() {
        var file;
        return _regeneratorRuntime().wrap(function _callee0$(_context0) {
          while (1) switch (_context0.prev = _context0.next) {
            case 0:
              file = _ref9.file;
              _this0.$api.aliOssSign(localStorage.getItem('userId')).then(/*#__PURE__*/function () {
                var _ref0 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee9(res) {
                  var url;
                  return _regeneratorRuntime().wrap(function _callee9$(_context9) {
                    while (1) switch (_context9.prev = _context9.next) {
                      case 0:
                        _context9.next = 2;
                        return _this0.uploadFile(localStorage.getItem('userId'), dayjs().format('YYYYMMDD'), res.data, file);
                      case 2:
                        url = _context9.sent;
                        _this0.$set(_this0.formData, 'certEntrustPassedInspection', url);
                      case 4:
                      case "end":
                        return _context9.stop();
                    }
                  }, _callee9);
                }));
                return function (_x5) {
                  return _ref0.apply(this, arguments);
                };
              }());
            case 2:
            case "end":
              return _context0.stop();
          }
        }, _callee0);
      }))();
    },
    certGreenFoodUpload: function certGreenFoodUpload(_ref1) {
      var _this1 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
        var file;
        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              file = _ref1.file;
              _this1.$api.aliOssSign(localStorage.getItem('userId')).then(/*#__PURE__*/function () {
                var _ref10 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee1(res) {
                  var url;
                  return _regeneratorRuntime().wrap(function _callee1$(_context1) {
                    while (1) switch (_context1.prev = _context1.next) {
                      case 0:
                        _context1.next = 2;
                        return _this1.uploadFile(localStorage.getItem('userId'), dayjs().format('YYYYMMDD'), res.data, file);
                      case 2:
                        url = _context1.sent;
                        _this1.$set(_this1.formData, 'certGreenFood', url);
                      case 4:
                      case "end":
                        return _context1.stop();
                    }
                  }, _callee1);
                }));
                return function (_x6) {
                  return _ref10.apply(this, arguments);
                };
              }());
            case 2:
            case "end":
              return _context10.stop();
          }
        }, _callee10);
      }))();
    },
    certOrganicFoodUpload: function certOrganicFoodUpload(_ref11) {
      var _this10 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
        var file;
        return _regeneratorRuntime().wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              file = _ref11.file;
              _this10.$api.aliOssSign(localStorage.getItem('userId')).then(/*#__PURE__*/function () {
                var _ref12 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee11(res) {
                  var url;
                  return _regeneratorRuntime().wrap(function _callee11$(_context11) {
                    while (1) switch (_context11.prev = _context11.next) {
                      case 0:
                        _context11.next = 2;
                        return _this10.uploadFile(localStorage.getItem('userId'), dayjs().format('YYYYMMDD'), res.data, file);
                      case 2:
                        url = _context11.sent;
                        _this10.$set(_this10.formData, 'certOrganicFood', url);
                      case 4:
                      case "end":
                        return _context11.stop();
                    }
                  }, _callee11);
                }));
                return function (_x7) {
                  return _ref12.apply(this, arguments);
                };
              }());
            case 2:
            case "end":
              return _context12.stop();
          }
        }, _callee12);
      }))();
    },
    topImageUpload: function topImageUpload(_ref13) {
      var _this11 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee14() {
        var file;
        return _regeneratorRuntime().wrap(function _callee14$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              file = _ref13.file;
              _this11.$api.aliOssSign(localStorage.getItem('userId')).then(/*#__PURE__*/function () {
                var _ref14 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee13(res) {
                  var url;
                  return _regeneratorRuntime().wrap(function _callee13$(_context13) {
                    while (1) switch (_context13.prev = _context13.next) {
                      case 0:
                        _context13.next = 2;
                        return _this11.uploadFile(localStorage.getItem('userId'), dayjs().format('YYYYMMDD'), res.data, file);
                      case 2:
                        url = _context13.sent;
                        _this11.$set(_this11.formData, 'topImage', url);
                      case 4:
                      case "end":
                        return _context13.stop();
                    }
                  }, _callee13);
                }));
                return function (_x8) {
                  return _ref14.apply(this, arguments);
                };
              }());
            case 2:
            case "end":
              return _context14.stop();
          }
        }, _callee14);
      }))();
    },
    previewFile: function previewFile(attr, index) {
      if (attr == 'reportFiles') {
        window.open(this.formData.reportFiles[index]);
      } else {
        window.open(this.formData[attr]);
      }
    },
    removeFile: function removeFile(attr, index) {
      if (attr == 'reportFiles') {
        this.formData.reportFiles.splice(index, 1);
      } else {
        this.formData[attr] = '';
      }
    },
    closeEditDialogShow: function closeEditDialogShow() {
      this.editDialogTitle = '';
      this.editDialogShow = false;
      this.initFormData(this.emptyFormData);
    },
    search: function search() {
      this.searchForm.page = 1;
      this.query();
    },
    pageChange: function pageChange(page) {
      this.searchForm.page = page;
      this.query();
    },
    sizeChange: function sizeChange(limit) {
      this.searchForm.page = 1;
      this.searchForm.limit = limit;
      this.query();
    },
    sortChange: function sortChange(column) {
      this.searchForm.page = 1;
      this.searchForm.sortField = column.order === 'ascending' ? '^' + this.camelToUnderline(column.prop) : column.order === 'descending' ? this.camelToUnderline(column.prop) : 'create_time';
      this.query();
    }
  }
};